import gql from 'graphql-tag';

const SIM_DASHBOARD_QUERY = gql`
  query Query($limit: Int!, $skip: Int!, $searchQuery: String) {
    simDashboard(limit: $limit, skip: $skip, searchQuery: $searchQuery) {
      simList {
        updatedOn
        simNumber
        networkProvider
        deviceSerialNo
        isActive
      }
      count
    }
  }
`;

export default SIM_DASHBOARD_QUERY;
